import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { EmpresaSupervisora, EmpresaSupervisoraFiltro } from "../../types/EmpresaSupervisora";


interface EmpresaSupervisoraState {
    empresaSupervisoraList: EmpresaSupervisora[];
    empresaSupervisoraSelected: EmpresaSupervisora;
    filtro: EmpresaSupervisoraFiltro;
    loading: boolean;
    errors: any;
    error: boolean,
    guardado: boolean,
}

export const empresaSupervisoraInitial: EmpresaSupervisora = {
    id: 0,
    nombreEmpresa: "",
    cuit: "",
    email: "",
    activo: true,
    empresasGestoras: [],
}

export const empresaSupervisoraFiltroInitial: EmpresaSupervisoraFiltro = {
    idEmpresaSupervisora: "",
    activo: null,
}

const initialState: EmpresaSupervisoraState = {
    empresaSupervisoraList: [],
    empresaSupervisoraSelected: empresaSupervisoraInitial,
    filtro: empresaSupervisoraFiltroInitial,
    loading: false,
    errors: [],
    error: false,
    guardado: false
}

const empresaSupervisoraSlice = createSlice({
    name: 'empresaSupervisora',
    initialState,
    reducers: {
        addEmpresaSupervisora: (state, data: PayloadAction<EmpresaSupervisora>): void => {
            state.empresaSupervisoraSelected = empresaSupervisoraInitial;
            state.error = false;
            state.guardado = true;
        },
        isLoading: (state, data: PayloadAction<boolean>): void => {
            state.loading = data.payload;
        },
        loadDataEmpresaSupervisora: (state, data: PayloadAction<EmpresaSupervisora>): void => {
            state.empresaSupervisoraSelected = data.payload;
            state.error = false;
        },
        loadListEmpresaSupervisora: (state, data: PayloadAction<EmpresaSupervisora[]>): void => {
            state.empresaSupervisoraList = data.payload;
        },
        loadingError: (state, data: PayloadAction<any>): void => {
            state.errors = data.payload;
            state.error = true;
        },
        visibleError: (state, data: PayloadAction<boolean>): void => {
            state.error = data.payload;
        },
        removeEmpresaSupervisora: (state, data: PayloadAction<number>): void => {
            state.empresaSupervisoraList = state.empresaSupervisoraList.filter(p => p.id !== data.payload)
        },
        setGuardado: (state, data: PayloadAction<boolean>): void => {
            state.guardado = data.payload;
        },
        loadDataFiltro: (state, data: PayloadAction<EmpresaSupervisoraFiltro>): void => {
            state.filtro = data.payload;
        },
    }
});
export const {
    addEmpresaSupervisora,
    isLoading,
    loadDataEmpresaSupervisora,
    loadListEmpresaSupervisora,
    loadingError,
    visibleError,
    removeEmpresaSupervisora,
    setGuardado,
    loadDataFiltro
} = empresaSupervisoraSlice.actions;

export default empresaSupervisoraSlice.reducer;
